import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from '../components/Navigation';
import '../styles/pages/settings.css';
import '../styles/pages/personal.css';

const ROLE_LABELS = { admin: 'Administrador', receptionist: 'Recepción', vet: 'Veterinario', support: 'Soporte' };

const sections = [
    {
        label: 'Equipo',
        items: [
            {
                key: 'personal',
                icon: '🗂️',
                color: 'cfg-icon--purple',
                title: 'Personal',
                desc: 'Expedientes, asistencia, vacaciones y nómina',
                route: '/settings/personal',
                adminOnly: true,
                isNew: true,
            },
            {
                key: 'users',
                icon: '👥',
                color: 'cfg-icon--purple',
                title: 'Gestión de usuarios',
                desc: 'Agrega, edita y administra usuarios y sus roles',
                route: '/users',
                adminOnly: true,
            },
            {
                key: 'contacts',
                icon: '📇',
                color: 'cfg-icon--blue',
                title: 'Contactos',
                desc: 'Pasantes, proveedores, comunidad y más',
                route: '/contacts',
            },
        ],
    },
    {
        label: 'Catálogo',
        items: [
            {
                key: 'catalog',
                icon: '🏷️',
                color: 'cfg-icon--green',
                title: 'Catálogo de servicios',
                desc: 'Servicios y precios en guardería, hotel, veterinaria y estética',
                route: '/settings/catalog',
                adminOnly: true,
            },
        ],
    },
    {
        label: 'Sistema',
        items: [
            {
                key: 'sysconfig',
                icon: '🔧',
                color: 'cfg-icon--gray',
                title: 'Configuración del sistema',
                desc: 'Ajustes y preferencias generales',
                soon: true,
            },
            {
                key: 'backup',
                icon: '💾',
                color: 'cfg-icon--gray',
                title: 'Copias de seguridad',
                desc: 'Gestiona copias de seguridad y mantenimiento',
                soon: true,
            },
            {
                key: 'reports',
                icon: '📊',
                color: 'cfg-icon--green',
                title: 'Reportes y analíticas',
                desc: 'Ingresos, cobranza, ocupación y pasivos',
                route: '/settings/reports',
                adminOnly: true,
                isNew: true,
            },
        ],
    },
];

export default function Settings() {
    const { role, user } = useAuth();
    const navigate = useNavigate();

    const visibleSections = sections.map(s => ({
        ...s,
        items: s.items.filter(item => !item.adminOnly || role === 'admin'),
    })).filter(s => s.items.length > 0);

    return (
        <>
            <Navigation />
            <div className="cfg-container">

                {/* Header */}
                <div className="cfg-header">
                    <div>
                        <h1 className="cfg-title">Configuración</h1>
                        <p className="cfg-subtitle">Administra el sistema y las preferencias del equipo.</p>
                    </div>
                </div>

                {/* Sections */}
                {visibleSections.map(section => (
                    <div key={section.label} className="cfg-section">
                        <p className="cfg-section-label">{section.label}</p>
                        <div className="cfg-list">
                            {section.items.map(item => (
                                <button
                                    key={item.key}
                                    className={`cfg-row${item.soon ? ' cfg-row--soon' : ''}`}
                                    onClick={item.route ? () => navigate(item.route) : undefined}
                                    disabled={item.soon}
                                >
                                    <div className={`cfg-icon ${item.color}`}>{item.icon}</div>
                                    <div className="cfg-row-info">
                                        <span className="cfg-row-title">{item.title}</span>
                                        <span className="cfg-row-desc">{item.desc}</span>
                                    </div>
                                    {item.soon
                                        ? <span className="cfg-soon-badge">Próximamente</span>
                                        : item.isNew
                                            ? <span className="cfg-newtag">Nuevo</span>
                                            : <span className="cfg-chevron">›</span>
                                    }
                                </button>
                            ))}
                        </div>
                    </div>
                ))}

                {/* Current session */}
                <div className="cfg-session">
                    <div className="cfg-session-avatar">
                        {(user?.name || user?.username || '?')[0].toUpperCase()}
                    </div>
                    <div className="cfg-session-info">
                        <span className="cfg-session-name">{user?.name || user?.username}</span>
                        <span className="cfg-session-role">{ROLE_LABELS[role] || role}</span>
                    </div>
                    <span className="cfg-session-dot" />
                </div>

            </div>
        </>
    );
}
